"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleProfilerOutput = exports.profileInc = void 0;
var debug_1 = require("../../shared/utils/debug");
var data = {};
var PERIOD = 15 * 1000;
var reporting = false;
var intervalId;
var enabled = true;
function triggerPeriodicOutput() {
    if (reporting)
        return;
    reporting = true;
    if (!enabled)
        return;
    intervalId = setInterval(function () {
        Object.keys(data).map(function (category) {
            var total = Object.values(data[category]).reduce(function (acc, v) { return acc + v; }, 0);
            (0, debug_1.debug)("Profile: ".concat(category, ". Total ").concat(total), data[category]);
        });
    }, PERIOD);
}
function profileInc(category, key) {
    if (!data[category]) {
        data[category] = {};
        triggerPeriodicOutput();
    }
    data[category][key] = (data[category][key] || 0) + 1;
}
exports.profileInc = profileInc;
function toggleProfilerOutput(status) {
    enabled = status;
    if (intervalId) {
        clearInterval(intervalId);
        intervalId = undefined;
    }
}
exports.toggleProfilerOutput = toggleProfilerOutput;
